export default __webpack_public_path__ + "static/media/O-073.e2f7a8ac.png";